module.exports = __webpack_public_path__ + "img/swap.ca0fdd64.svg";